import axios from '@/requests';
import { VoiceRecord } from '@/store/modules/voiceRecord/types';


export const voiceRecordAPI = {
    async getVoiceRecordListByUid(projId: string, uid: string) {
        try {
            const res = await axios.get<VoiceRecord[]>('/voiceRecord/listVoiceRecord', { "projId": projId, "uid": uid });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getVoiceRecordTimeLineByProjIdAndUid(projId: string, uid: string) {
        try {
            const res = await axios.get<VoiceRecord[]>('/voiceRecord/getVoiceRecordTimeLineByProjIdAndUid', { "projId": projId, "uid": uid });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async getVoiceRecordDownLoadLink(projId: string, uid: string, id: number) {
        try {
            const res = await axios.get<VoiceRecord[]>('/mega/getMegaDownloadFileLink', { "projId": projId, "uid": uid, "id": id });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },
    async listVoiceRecordByTime(projId: string, uid: string, timeStamp: string) {
        try {
            const res = await axios.get<VoiceRecord[]>('/voiceRecord/listVoiceRecordByTime', { "projId": projId, "uid": uid, "timeStamp": timeStamp });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    },


}